// Ochiq ariza sahifasi /apply, ru
export default {
  brand: "Работа для водителей",
  closedTitle: "Приём заявок сейчас закрыт.",
  closedDesc: "Пожалуйста, загляните позже.",
  h1: "Заявка на работу водителем грузовика CDL-A",
  lead: "Займёт 1 минуту. Рекрутер вам позвонит.",
  fullName: "Полное имя",
  phone: "Телефон",
  email: "Email",
  state: "Штат",
  statePlaceholder: "Штат",
  cdlClass: "Класс CDL",
  classPlaceholder: "Класс",
  classA: "Класс A",
  classB: "Класс B",
  classC: "Класс C",
  experience: "Стаж вождения",
  choose: "Выберите",
  exp: { lt1: "Меньше 1 года", y1_2: "1–2 года", y2_5: "2–5 лет", y5: "5+ лет" },
  equipment: "Какую технику хотите водить",
  website: "Сайт",
  consent: "Я согласен(на) на связь по телефону, SMS и email по поводу работы водителем. Согласие не является условием трудоустройства. Могут применяться тарифы на SMS и данные.",
  submit: "Отправить заявку",
  noSsn: "В этой форме мы никогда не спрашиваем SSN.",
  sendFailed: "Не удалось отправить заявку. Проверьте соединение и попробуйте снова.",
  errors: {
    name: "Введите полное имя",
    nameTwo: "Введите имя и фамилию",
    phone: "Введите действительный номер телефона США",
    email: "Введите действительный email",
    state: "Выберите штат",
    cdl: "Выберите класс CDL",
    experience: "Выберите стаж",
    consent: "Требуется согласие",
  },
  thanks: "Спасибо, {{name}}!",
  thanksAnon: "Спасибо!",
  received: "Ваша заявка получена. Рекрутер позвонит в течение 1 рабочего дня.",
  questions: "Вопросы? Задайте их рекрутеру при звонке.",
  back: "Назад к {{company}}",
};
